// @flow
import React, { useContext } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { withLeaflet } from 'react-leaflet';
import { Box, Button } from 'grommet';
import { MapContext } from 'esm-web-pro/containers/map/context';
import type { LeafletContext } from 'react-leaflet/src';
import ReactTooltip from 'react-tooltip';
import { defineMessages, useIntl } from 'react-intl';
import MultiselectIcon from 'esm-web-pro/components/maps/multiselect/MultiselectIcon';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';


type Props = {
    leaflet: LeafletContext,
}

const messages = defineMessages({
    groupActions: {
        id: 'group-actions-tooltip',
        defaultMessage: 'Group actions',
    },
});

const GroupObjectsControl = (props: Props) => {
    const history = useHistory();
    const match = useRouteMatch();
    const { formatMessage } = useIntl();
    const { is_draft: isDraft } = useContext(MapContext);
    const { leaflet: { map }, leaflet: { map: { grouping } } } = props;

    const handleOpen = (e) => {
        map.grouping = true;
        e.stopPropagation();
        history.push(`${match.url.split('/layer')[0]}/group/`);
    };

    return (isDraft && !grouping) ? (
        <Box pad={{ bottom: 'xsmall' }}>
            <Button
                plain
                icon={<MultiselectIcon width="30px" />}
                onClick={handleOpen}
                hoverIndicator="light-1"
                data-tip
                data-for="test"
            />
            <ReactTooltip
                id="test"
                effect="solid"
                place="left"
                className="react-tooltip"
            >
                <LabelText>{formatMessage(messages.groupActions)}</LabelText>
            </ReactTooltip>
        </Box>
    ) : null;
};

export default withLeaflet(GroupObjectsControl);
